<template>
    <ContentCard theme="navy" icon="assets/images/illu-rope.svg">
        <template #title>HOW DO WE MAKE A ROPE?</template>
        <template #description>Everyone needs a piece of rope - learn how to make strong rope from
            Australian plants!
        </template>
        <template #buttons>
            <ButtonPill icon="play" class="card__btn me-8"
                        @click.native="$store.commit('SET_LIGHTBOX', 'IJMbK5h9Jr8')">Watch Now
            </ButtonPill>
            <ButtonPill href="/pdfs/Making-Cordage.pdf" target="_blank" icon="file"
                        class="card__btn" orange>ACTIVITY
            </ButtonPill>
        </template>
    </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard';
import ButtonPill from '@/components/ButtonPill';
export default {
    components: {ButtonPill, ContentCard}
};
</script>
